var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08185 0H20.9215C22.6164 0 24.0019 1.38603 24.0019 3.08089V20.9206C24.0019 22.6149 22.6164 24 20.9215 24H3.08185C1.38699 24 0 22.6148 0 20.9206V3.08089C0 1.38603 1.38699 0 3.08185 0ZM17.4851 2.66557C16.89 2.66557 16.4046 3.15289 16.4046 3.74766V6.33299C16.4046 6.92799 16.89 7.41419 17.4851 7.41419H20.1975C20.7917 7.41419 21.2781 6.92799 21.2781 6.33299V3.74766C21.2781 3.15289 20.7917 2.66557 20.1975 2.66557H17.4851ZM21.2884 10.1493H19.1766C19.3768 10.8033 19.4854 11.4931 19.4854 12.2102C19.4854 16.2011 16.1439 19.438 12.0235 19.438C7.90423 19.438 4.5626 16.2011 4.5626 12.2102C4.5626 11.4931 4.67221 10.8033 4.87151 10.1493H2.66821V20.2887C2.66821 20.8137 3.09697 21.2409 3.62157 21.2409H20.3355C20.8605 21.2409 21.2884 20.8137 21.2884 20.2887V10.1493ZM12.0236 7.27786C9.36259 7.27786 7.20402 9.36827 7.20402 11.9493C7.20402 14.5276 9.36259 16.6196 12.0236 16.6196C14.6861 16.6196 16.8447 14.5276 16.8447 11.9493C16.8447 9.36819 14.6861 7.27786 12.0236 7.27786Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.bd239eb24946856b762d55f56b28014a.svg";
export { ForwardRef as ReactComponent };